import type { RouteRecordRaw } from 'vue-router'
import {
  toAnyPermission,
  virtualEmployeeRouteCandidates,
} from '@/config/businessRoutePermissions'
import { legacyTenantRedirect, maybeRouteName } from './tenantScoped'

const createVirtualEmployeeChildren = (withNames: boolean): RouteRecordRaw[] => [
  {
    path: 'dashboard',
    ...maybeRouteName(withNames, 'virtual-employee-dashboard'),
    component: () => import('@/views/virtual-employee/VirtualEmployeeDashboard.vue'),
    meta: { title: '虚拟员工价值驾驶舱', permission: 'virtual_employee:dashboard:view' },
  },
  {
    path: 'config',
    ...maybeRouteName(withNames, 'virtual-employee-config'),
    component: () => import('@/views/virtual-employee/VirtualEmployeeConfig.vue'),
    meta: { title: '虚拟员工配置工作台', permission: 'virtual_employee:config:view' },
  },
]

const createVirtualEmployeeRoute = (path: string, defaultRouteBasePath: string, withNames: boolean): RouteRecordRaw => ({
  path,
  component: () => import('@/views/virtual-employee/VirtualEmployeeLayout.vue'),
  ...(withNames ? {} : { beforeEnter: legacyTenantRedirect }),
  meta: {
    permission: toAnyPermission(virtualEmployeeRouteCandidates),
    defaultRouteBasePath,
    defaultRouteCandidates: virtualEmployeeRouteCandidates,
    ...(!withNames ? { legacyTenantRedirect: true } : {}),
  },
  children: createVirtualEmployeeChildren(withNames)
})

const virtualEmployeeRoutes: RouteRecordRaw[] = [
  createVirtualEmployeeRoute('t/:tenantCode/virtual-employee', '/t/:tenantCode/virtual-employee', true),
  createVirtualEmployeeRoute('virtual-employee', '/virtual-employee', false),
]

export default virtualEmployeeRoutes
